export default __webpack_public_path__ + "static/media/vertical_clean.045f7329.png";